import { getCollectionFieldTraitOptions, getFieldOptionsForSelect } from '../pluginComponentApi';
import randomId from 'random-id';
import {
  pageCollectionFields,
  BelongsCreatedByRefField,
  BelongsToReferenceField,
} from 'drapcode-constant';
import {
  filterFieldsForDataTable,
  filterFieldsForTypesenseCollection,
} from '../../fields/FieldTypes';
import Swal from 'sweetalert2';
export default function (editor, opts = {}) {
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const { pageCollection, projectId, collections } = opts;
  const tableId = 'dc-data-table-' + randomId(8, '');
  const dtMultiSelectBtnId = 'dt-multi-select-' + randomId(8, '');

  domc.addType('table', {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          'custom-name': 'Table',
          tagName: 'table',
          classes: ['table'],
          traits: [].concat(defaultModel.prototype.defaults.traits),
        },
      },
      {
        isComponent(el) {
          if (el && el.classList && el.classList.contains('table')) {
            return { type: 'table' };
          }
        },
      },
    ),
    view: defaultView,
  });

  domc.addType('cell', {
    model: defaultModel.extend(
      {
        defaults: {
          ...domc.getType('cell').model.prototype.defaults,
          type: 'cell',
          tagName: 'td',
          draggable: ['tr'],
          editable: true,
          traits: [
            {
              type: 'insertField',
              name: 'insertField',
              label: 'Select Column Field',
            },
          ].concat(domc.getType('cell').model.prototype.defaults.traits),
        },

        async init() {
          const collectionTable = this.closestType('data-table');
          if (collectionTable) {
            const selectedCollectionName = collectionTable.get('collectionName');
            if (selectedCollectionName) {
              const collection = collectionTable.get('selectedCollectionData');
              const index = collections.find(
                (item) => item['collectionName'] === collection.collectionName,
              );
              if (index) {
                collection.fields = index.fields;
              }
              let fieldOptions = await getCollectionFieldTraitOptions(collection, collections);

              if (fieldOptions) {
                this.getTrait('insertField').set('options', fieldOptions);

                // if (this.get('tagName') === 'th') {
                //   this.getTrait('insertField').set('options', fieldOptions);
                // }
              }

              const collectionFrom = collectionTable.get('collectionFrom');
              if (collectionFrom === 'browserSession') {
                const sessionFieldTrait = this.getTrait('data-session-field');
                if (!sessionFieldTrait) {
                  this.addTrait(
                    {
                      type: 'text',
                      label: 'Session Field',
                      name: 'data-session-field',
                      placeholder: 'ex: data or, response.data', // Placeholder to show inside the input
                    },
                    { at: this.getTraitIndex('insertField') + 1 },
                  );
                }
              } else {
                const sessionFieldTrait = this.getTrait('data-session-field');
                if (sessionFieldTrait) {
                  this.removeTrait('data-session-field');
                }
              }
            }
          }
        },
      },
      {
        isComponent(el) {
          let result = '';
          const tag = el.tagName;

          if (tag === 'TD' || tag === 'TH') {
            result = {
              type: 'cell',
              tagName: tag.toLowerCase(),
            };
          }
          return result;
        },
      },
    ),
    view: defaultView.extend({
      events: {
        submit(e) {
          e.preventDefault();
        },
      },
      init({ model }) {},
    }),
  });

  domc.addType('data-table', {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          name: 'Data Table',
          resizable: 1,
          collectionName: '',
          collectionFrom: '',
          icon: '<i class="wb webconnect-table"></i>',
          finderUuid: '',
          enableMultiSelect: '',
          triggerMultiSelect: true,
          hideWhenEmpty: '',
          numberPerPage: 10,
          projectId: projectId,
          serverUrl: `${process.env.REACT_EXCHANGE_ENGINE}`,
          traits: [
            {
              type: 'data-table-collection',
              label: false,
              name: 'collectionName',
              changeProp: 1,
            },
            {
              type: 'checkbox',
              label: 'Multi Select Rows',
              name: 'enableMultiSelect',
              changeProp: 1,
            },
            {
              type: 'number',
              label: 'Records Per Page',
              name: 'numberPerPage',
              changeProp: 1,
              value: '{[numberPerPage]}',
            },
            ...domc.getType('table').model.prototype.defaults.traits,
          ],
          script: function () {
            let collectionId = '{[ collectionName ]}';
            const finderId = '{[ finderUuid ]}';
            const fieldName = '{[ fieldName ]}';
            const recordsPerPage = '{[ numberPerPage ]}';
            let collectionFrom = '{[ collectionFrom ]}';
            let sessionDataPath = '{[ sessionDataPath ]}';

            let selectedCollectionData = '{[ selectedCollectionStr ]}';
            selectedCollectionData = selectedCollectionData.replaceAll('**##', '"');

            const externalQueryParamKeys = [];
            if (selectedCollectionData && selectedCollectionData !== 'undefined') {
              selectedCollectionData = JSON.parse(selectedCollectionData);
              const selectedFilter = selectedCollectionData.finders.find(
                (finder) => finder.uuid === finderId,
              );

              if (selectedFilter && selectedFilter.conditions) {
                selectedFilter.conditions.forEach((condition) => {
                  if (condition.requiredExternal) {
                    const {
                      query: { value },
                    } = condition;
                    if (value.includes('---')) {
                      const values = value.split('---');
                      externalQueryParamKeys.push(values[0]);
                      externalQueryParamKeys.push(values[1]);
                    } else {
                      externalQueryParamKeys.push(value);
                    }
                  }
                });
              }
            }

            let paginationData = {};
            paginationData.numberPerPage = recordsPerPage ? recordsPerPage : 5;
            paginationData.filteredItemsUrl = `collection-table/${collectionId}/finder/${finderId}/items`;
            paginationData.currentPage = 1;
            paginationData.currentDateRange = 0;
            paginationData.dataTable = this;
            paginationData.numberOfPages = 0;
            paginationData.finderId = finderId;
            paginationData.collectionName = collectionId;
            paginationData.fieldName = fieldName;
            paginationData.externalQueryParamKeys = externalQueryParamKeys;
            paginationData.browserSessionDataPath = sessionDataPath;

            if (selectedCollectionData && selectedCollectionData !== 'undefined') {
              paginationData.externalApiId = selectedCollectionData.externalApiId;
              paginationData.responseDataMapping = selectedCollectionData.responseDataMapping;
              paginationData.bodyDataFrom = selectedCollectionData.bodyDataFrom;
              paginationData.sendFormData = !!selectedCollectionData.sendFormData;
            }

            const pagination = this.querySelector('[data-gjs=pagination]');
            const search = this.querySelector('.search-form');
            if (search) {
              search.addEventListener('submit', function (ev) {
                ev.preventDefault();
                let forNonPersistentData = false;
                if (
                  collectionFrom.trim() === 'externalAPIResponse' &&
                  typeof loadDataTableFromExternalAPI !== 'undefined'
                ) {
                  console.log('*** Search in DataTable for Non Persistent Data... ');
                  forNonPersistentData = true;
                }
                paginationData['event'] = ev;
                searchInDataTable(paginationData, '', forNonPersistentData);
              });

              const enableAutoSearch = search.hasAttribute('data-enableautosearch');
              if (typeof autoSearchInDataSearch !== 'undefined') {
                autoSearchInDataSearch(enableAutoSearch, search);
              }
            }

            if (
              ![
                'externalAPIResponse',
                'browserSession',
                'userFields',
                'tenantFields',
                'userSettingsFields',
                'subTenantFields',
                'typesenseCollection',
              ].includes(collectionFrom.trim()) &&
              typeof loadDataTable !== 'undefined'
            ) {
              console.log('*** Loading DataTable from Collection...');
              loadDataTable(finderId, collectionId, paginationData);
            }
            if (
              ['userFields', 'tenantFields', 'userSettingsFields', 'subTenantFields'].includes(
                collectionFrom.trim(),
              ) &&
              typeof loadDataTableLocalStorage !== 'undefined'
            ) {
              if (collectionFrom.trim() === 'userFields') {
                console.log('*** Loading DataTable from User Fields...');
                paginationData.localStorageKey = 'user';
              } else if (collectionFrom.trim() === 'tenantFields') {
                console.log('*** Loading DataTable from Tenant Fields...');
                paginationData.localStorageKey = 'tenant';
              } else if (collectionFrom.trim() === 'userSettingsFields') {
                console.log('*** Loading DataTable from User Settings Fields...');
                paginationData.localStorageKey = 'userSettings';
              } else if (collectionFrom.trim() === 'subTenantFields') {
                console.log('*** Loading DataTable from Sub Tenant Fields...');
                paginationData.localStorageKey = 'subTenant';
              }
              loadDataTableLocalStorage(paginationData);
            }

            if (
              collectionFrom.trim() === 'externalAPIResponse' &&
              typeof loadDataTableFromExternalAPI !== 'undefined'
            ) {
              console.log('*** Loading DataTable from External API...');
              loadDataTableFromExternalAPI(paginationData);
            }

            if (
              collectionFrom.trim() === 'browserSession' &&
              typeof loadDataTableFromBrowserSession !== 'undefined'
            ) {
              console.log('*** Loading DataTable from Browser Session...');
              loadDataTableFromBrowserSession(collectionId, paginationData);
            }
            if (
              collectionFrom.trim() === 'typesenseCollection' &&
              typeof loadDataTable !== 'undefined'
            ) {
              console.log('*** Loading DataTable from Typesense Collection...');
              loadDataTable(finderId, collectionId, paginationData, true);
            }
            if (pagination) {
              if (this.querySelector('.next')) {
                this.querySelector('.next').addEventListener('click', function (ev) {
                  nextDataTablePage(paginationData);
                });
              }
              if (this.querySelector('.first')) {
                this.querySelector('.first').addEventListener('click', function (ev) {
                  firstDataTablePage(paginationData);
                });
              }
              if (this.querySelector('.last')) {
                this.querySelector('.last').addEventListener('click', function (ev) {
                  lastDataTablePage(paginationData);
                });
              }

              if (this.querySelector('.previous')) {
                this.querySelector('.previous').addEventListener('click', function (ev) {
                  previousDataTablePage(paginationData);
                });
              }
            }
          },
        },
        init() {
          //Populate Previous External Query from Collection Finder
          const collection = this.get('selectedCollectionData');
          const finder = this.get('finderUuid');
          const finders = collection ? collection.finders : [];
          const selectedFinder = finders.find((currentFinder) => currentFinder.uuid === finder);
          if (selectedFinder && selectedFinder.noOfExternalParams > 0) {
            let pageCollectionOptions = pageCollection ? pageCollection.options : [];
            pageCollectionOptions = pageCollectionOptions.filter((opt) =>
              [...pageCollectionFields, ...BelongsToReferenceField].includes(opt.type),
            );
            const externalQueryParamKeys = [];
            if (selectedFinder.conditions) {
              selectedFinder.conditions.forEach((condition) => {
                if (condition.requiredExternal) {
                  const {
                    query: { value },
                  } = condition;
                  if (value.includes('---')) {
                    const values = value.split('---');
                    externalQueryParamKeys.push(values[0]);
                    externalQueryParamKeys.push(values[1]);
                  } else {
                    externalQueryParamKeys.push(value);
                  }
                }
              });
            }

            if (externalQueryParamKeys.length > 0) {
              externalQueryParamKeys.forEach((extParam) => {
                this.addTrait({
                  name: extParam,
                  label: extParam,
                  options: pageCollectionOptions,
                  title: extParam,
                  type: 'finder-query-param-trait',
                });
              });
            }
          }
          this.on('change:collectionName', this.handleCollectionChange);
          this.on('change:finderUuid', this.handleFinderChange);
          this.on('change:enableMultiSelect', this.handleEnableMultiSelectChange);
        },
        async handleEnableMultiSelectChange() {
          const enableMultiSelect = this.get('enableMultiSelect');
          let triggerMultiSelect = this.get('triggerMultiSelect');
          this.set('triggerMultiSelect', true);
          if (triggerMultiSelect) {
            const heading = `${enableMultiSelect ? 'Enable' : 'Disable'} Multi Select Rows?`;
            const description = enableMultiSelect
              ? `<div class='text-justify'>
                <ul>
                  <li>It will add checkbox column.</li>
                  <li>It will add "Open Bulk Selection Modal" button.</li>
                  <li>Reset the table columns to initial state.</li>
                </ul>
              <div>`
              : `<div class='text-justify'>
                <ul>
                  <li>It will remove checkbox column.</li>
                  <li>It will remove "Open Bulk Selection Modal" button.</li>
                  <li>Reset the table columns to initial state.</li>
                </ul>
              <div>`;

            const result = await Swal.fire({
              title: heading,
              html: description,
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: enableMultiSelect ? '#3085d6' : '#d33',
              cancelButtonColor: '#757f91',
              confirmButtonText: `Yes, ${enableMultiSelect ? 'enable' : 'disable'} it!`,
              allowOutsideClick: false,
            });
            if (result.isConfirmed) {
              await this.handleCollectionChange();
            } else {
              const enableMultiSelectTrait = this.getTrait('enableMultiSelect');
              if (enableMultiSelectTrait) {
                enableMultiSelectTrait.el.checked = !enableMultiSelect;
              }
              this.set('triggerMultiSelect', false);
              this.set('enableMultiSelect', !enableMultiSelect);
            }
          }
        },
        async handleCollectionChange() {
          const collectionName = this.get('collectionName');
          const collection = this.get('selectedCollectionData');
          const enableMultiSelect = this.get('enableMultiSelect');
          const collectionFrom = this.get('collectionFrom');
          const externalAPIResponseDataMapping = this.get('externalAPIResponseDataMapping');
          let options = [];
          let tableBodyCells = '';
          let tableHeadingCells = '';

          if (enableMultiSelect) {
            tableBodyCells = `<td scope="col" data-selected-column="action_select_checkbox" type="action_select_checkbox">
            <div data-gjs="checkbox-item">
              <input type="checkbox" value="" data-gjs="dt-item-check" id="action-select-item">
              <label class="form-check-label" for="action-select-item"></label>
            </div>
          </td>`;
            tableHeadingCells = `<th scope="col" data-selected-column="action_select_checkbox_all" type="action_select_checkbox_all">
            <div data-gjs="checkbox-all">
              <input type="checkbox" value="" data-gjs="dt-item-check-all" id="action-select-item-all" onchange=toggleAllDataTableItems(event,'${tableId}')>
              <label class="form-check-label" for="action-select"></label>
            </div>
          </th>`;
          }

          if (collectionName && collection) {
            let fieldOptions = await getCollectionFieldTraitOptions(collection, collections);
            fieldOptions = filterFieldsForDataTable(fieldOptions);
            if (collectionFrom && collectionFrom === 'externalAPIResponse') {
              fieldOptions.map((field, index) => {
                tableHeadingCells += `<th data-selected-column="${
                  field.id
                }" data-selected-response-map-column="${
                  externalAPIResponseDataMapping && externalAPIResponseDataMapping[field.id]
                    ? externalAPIResponseDataMapping[field.id]
                    : field.id
                }" type="${field.type}"><div data-gjs-type="text" title="${field.name}">${
                  field.name
                }</div></th>`;
                tableBodyCells += ` <td data-selected-column="${
                  field.id
                }" data-selected-response-map-column="${
                  externalAPIResponseDataMapping && externalAPIResponseDataMapping[field.id]
                    ? externalAPIResponseDataMapping[field.id]
                    : field.id
                }"><div>${field.name}'s value</div></td>`;
              });
            } else if (collectionFrom && collectionFrom === 'typesenseCollection') {
              fieldOptions = filterFieldsForTypesenseCollection(fieldOptions, collection);
              fieldOptions.map((field) => {
                tableHeadingCells += `<th data-selected-column="${field.id}" type="${field.type}"><div data-gjs-type="text" title="${field.name}">${field.name}</div></th>`;
                tableBodyCells += ` <td data-selected-column="${field.id}"><div>${field.name}'s value</div></td>`;
              });
            } else {
              fieldOptions.map((field, index) => {
                tableHeadingCells += `<th data-selected-column="${field.id}" type="${field.type}"><div data-gjs-type="text" title="${field.name}">${field.name}</div></th>`;
                tableBodyCells += ` <td data-selected-column="${field.id}"><div>${field.name}'s value</div></td>`;
              });
            }

            tableBodyCells += `<td scope="col" data-selected-column="action" type="action">
                                             <a data-gjs="data-table-link" data-gjs-type="link" href="" class="btn btn-primary btn-sm" style="margin: 0px 2px">Edit</a>
                                             <a data-gjs="data-table-link" data-gjs-type="link" href="" class="btn btn-danger btn-sm" style="margin: 0px 2px">Delete</a>
                                         </td>`;
            tableHeadingCells += `<th scope="col" data-selected-column="action" type="action"><div data-gjs-type="text">Actions</div></th>`;

            let tableContent = `
                        <table id="${tableId}" class="table table-bordered table-resizable">
                            <thead>
                                <tr data-js="row" data-custom-js-row="collection-row">
                                         ${tableHeadingCells}
                                </tr>
                            </thead>
                            <tbody data-js="table-body">
                             <tr data-js="row" data-custom-js-row="collection-row" data-row="generated">
                                         ${tableBodyCells}
                             </tr>
                            </tbody>
                         </table>
                           `;

            const searchForm = this.findType('search-form');
            if (searchForm && searchForm.length > 0) {
              searchForm.forEach((component) => {
                component.set('collectionName', collectionName);
                const { sourceOfOrigin } = collection || '';
                if (sourceOfOrigin) {
                  component.set('data-datasource', sourceOfOrigin);
                  const attrs = component.getAttributes();
                  attrs['data-datasource'] = sourceOfOrigin;
                  component.setAttributes(attrs);
                }
              });
            }

            if (collection) {
              const { sourceOfOrigin } = collection;
              if (sourceOfOrigin) {
                const paginationComp = this.findType('pagination');

                if (paginationComp && paginationComp.length > 0) {
                  paginationComp.forEach((component) => {
                    component.set('data-datasource', sourceOfOrigin);
                    const attrs = component.getAttributes();
                    attrs['data-datasource'] = sourceOfOrigin;
                    component.setAttributes(attrs);
                  });
                }
              }
            }

            const dtBulkUpdate = this.findType('box');
            if (enableMultiSelect) {
              if (dtBulkUpdate.length > 0) {
                dtBulkUpdate.forEach((component) => {
                  component.removeClass('d-none');
                  const allButtons = component.findType('bootstrap_button');
                  allButtons[0].addAttributes({ id: `${dtMultiSelectBtnId}` });
                });
              }
            } else {
              if (dtBulkUpdate.length > 0) {
                dtBulkUpdate.forEach((component) => {
                  component.addClass('d-none');
                });
              }
            }

            const tableComponents = this.findType('table');
            if (tableComponents.length > 0) {
              tableComponents.forEach((component) => {
                component.replaceWith(tableContent);
              });
            }
          } else {
            const tableContent = `
            <table class="table table-bordered table-resizable">
              <tr><td></td><td></td><td></td></tr>
              <tr><td></td><td></td><td></td></tr>
              <tr><td></td><td></td><td></td></tr>
            </table>
            `;
            const tableComponents = this.findType('table');
            if (tableComponents.length > 0) {
              tableComponents.forEach((component) => {
                component.replaceWith(tableContent);
              });
            }
          }
        },
        async handleFinderChange() {
          const collectionName = this.get('collectionName');
          const collection = this.get('selectedCollectionData');
          const finder = this.get('finderUuid');
          const finders = collection ? collection.finders : [];
          const selectedFinder = finders.find((currentFinder) => currentFinder.uuid === finder);
          const allTraits = this.get('traits');
          const removeTraits = [];
          allTraits.forEach((trait) => {
            if (trait.props().type === 'finder-query-param-trait') {
              removeTraits.push(trait.props().name);
            }
          });
          removeTraits.map((trait) => this.removeTrait(trait));

          if (selectedFinder && selectedFinder.noOfExternalParams > 0) {
            let pageCollectionOptions = pageCollection ? pageCollection.options : [];
            pageCollectionOptions = pageCollectionOptions.filter((opt) =>
              [...pageCollectionFields, ...BelongsToReferenceField].includes(opt.type),
            );
            const externalQueryParamKeys = [];
            if (selectedFinder.conditions) {
              selectedFinder.conditions.forEach((condition) => {
                if (condition.requiredExternal) {
                  const {
                    query: { value },
                  } = condition;
                  if (value.includes('---')) {
                    const values = value.split('---');
                    externalQueryParamKeys.push(values[0]);
                    externalQueryParamKeys.push(values[1]);
                  } else {
                    externalQueryParamKeys.push(value);
                  }
                }
              });
            }

            if (externalQueryParamKeys.length > 0) {
              externalQueryParamKeys.forEach((extParam) => {
                this.addTrait({
                  name: extParam,
                  label: extParam,
                  options: pageCollectionOptions,
                  title: extParam,
                  type: 'finder-query-param-trait',
                });
              });
            }
          }
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === 'data-table') {
            return {
              type: 'data-table',
            };
          }
        },
      },
    ),
    view: defaultView.extend({
      init({ model }) {
        this.listenTo(model, 'change:collectionName', this.updateScript);
        this.listenTo(model, 'change:finderUuid', this.updateScript);
        this.listenTo(model, 'change:collectionFrom', this.updateScript);
        this.listenTo(model, 'change:sessionDataPath', this.updateScript);
      },
    }),
  });

  editor.TraitManager.addType('insertField', {
    createInput({ trait }) {
      // Here we can decide to use properties from the trait
      const traitOpts = trait.get('options') || [];
      const options = traitOpts;

      // Create a new element container add some content
      const el = document.createElement('div');
      el.innerHTML = `
      <select class="insert-field">
        ${getFieldOptionsForSelect(options)}
      </select>
    `;
      return el;
    },

    // Update the component based element changes
    onEvent({ elInput, component }) {
      const inputType = elInput.querySelector('.insert-field');
      let selectField = inputType.value;

      if (selectField.includes("'")) {
        selectField = selectField.split("'").join('"');
      }
      let attr = component.getAttributes();
      const selectedOption = inputType.options[inputType.selectedIndex];
      const fieldType = selectedOption.getAttribute('type');
      /*
      if (ReferenceCreatedByFields.includes(fieldType)) {
        attr['metaData'] = selectedOption.getAttribute('metaData').split("'").join('"');
      }
      */
      if (BelongsCreatedByRefField.includes(fieldType)) {
        attr['metaData'] = selectedOption.getAttribute('metaData').split("'").join('"');
      } else {
        delete attr['metaData'];
      }
      attr['data-selected-column'] = selectField;
      attr['type'] = fieldType;
      component.components(`<div>${selectedOption.text}</div>`);
      component.setAttributes(attr);
    },

    onUpdate({ elInput, component }) {
      const dataSelectedColumn = component.getAttributes()['data-selected-column'] || '';
      const inputType = elInput.querySelector('.insert-field');
      inputType.value = dataSelectedColumn;
      inputType.dispatchEvent(new CustomEvent('change'));
    },
  });
}
